<template>
  <div class="col-md-6 mb-3">
    <div class="list-group card-item" style="border-radius: 1.2rem">
      <ListGroupItem
        style="padding-top: 0.5rem; padding-bottom: 0.5rem;"
      >
        <div class="flex-1 text-break">
          <div style="font-size: 1rem" v-if="props.data._id">
            {{ props.data.name }}
          </div>

          <div class="text-gray-600" v-if="props.data._id">
            {{ getControllerId(props.data) }}
          </div>

          <div class="form-check" v-else>
            <input
              class="form-check-input"
              type="checkbox"
              :id="`gridCheck${props.index}`"
              :checked="onSelectChecked(props.data)"
              @change="() => onSelectChange(props.data)"
            />
            <label class="form-check-label" :for="`gridCheck${props.index}`">
              {{ getControllerId(props.data) }}
            </label>
          </div>
        </div>
        <div v-if="props.data._id" @click.stop="onDeleteClick">
          <i class="fa-regular fa-trash-can"></i>
        </div>
      </ListGroupItem>

      <ListGroupItem
        class="text-gray-800"
        style="padding-top: 0.3rem; padding-bottom: 0.3rem;"
        v-if="props.data.type == DeviceType.Lamp"
      >
        {{ getInfo(props.data) }}
      </ListGroupItem>

      <ListGroupItem
        class="text-gray-800"
        style="padding-top: 0.3rem; padding-bottom: 0.3rem;"
      >
        장치 타입 : {{ getType(props.data) }}
      </ListGroupItem>

      <!-- <div class="list-group-item d-flex align-items-center text-gray-800">
        {{ props.data }}
      </div> -->
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  reactive,
  getCurrentInstance,
  onBeforeMount,
  computed,
  onMounted,
  watch,
} from 'vue';
import Card from '@/common/template/components/bootstrap/Card.vue';
import CardBody from '@/common/template/components/bootstrap/CardBody.vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { DeviceType } from '@/common/constants';
import { formatDisplayLampPorts } from '@/common/utils/controllerDisplayName';
import ListGroupItem from '@/common/components/widgets/ListGroupItem.vue';

const { emit } = getCurrentInstance();
const router = useRouter();
const props = defineProps([
  'index',
  'data',
  'onSelectChecked',
  'onSelectChange',
]);
const store = useStore();
const backColor = computed(() => {
  if (props.index % 5 === 0) {
    return 'bg-gradient-custom-orange';
  } else if (props.index % 5 === 1) {
    return 'bg-gradient-custom-pink';
  } else if (props.index % 5 === 2) {
    return 'bg-gradient-custom-teal';
  } else if (props.index % 5 === 3) {
    return 'bg-gradient-custom-indigo';
  } else {
    return 'bg-gradient-custom-blue';
  }
});

const deviceName = ref('');

onMounted(() => {
  console.log('DeviceItem.onMounted().props =>', props);
});

const getInfo = (data) => {
  if (data.isVirtual) {
    return "가상 버튼";
  }
  if (data.type == DeviceType.Lamp) {
    const controllerId = data._id ? data.controllerId : data.serial;
    const ports = data._id ? data.item?.ports : data.data?.port;
    return `연결포트 : ${formatDisplayLampPorts(ports, controllerId)}`;
  }
  else if (data.type == DeviceType.Boiler)
    return `시리얼번호 : ${data._id ? data.item.serial : data.data.serial}`;
  else if (data.type == DeviceType.Curtain || data.type == DeviceType.Dooya || data.type == DeviceType.Rono)
    return `시리얼번호 : ${data._id ? data.item.serial : data.data.serial}`;
  else if (data.type == DeviceType.Ventilator)
    return `시리얼번호 : ${data._id ? data.item.serial : data.data.serial}`;
};

const getType = (data) => {
  if (data.type == DeviceType.Lamp) return '조명';
  else if (data.type == DeviceType.Boiler) return '보일러';
  else if (data.type == DeviceType.Curtain || data.type == DeviceType.Dooya) return '커튼';
  else if (data.type == DeviceType.Rono) return '블라인드';
  else if (data.type == DeviceType.Ventilator) return '환풍기';
};

const getDeviceType = (type) => {
  switch (type) {
    case DeviceType.Lamp:
      return '조명';
    case DeviceType.Boiler:
      return '보일러';
    case DeviceType.Curtain:
    case DeviceType.Dooya:
      return '커튼';
    case DeviceType.Rono:
      return '블라인드';
    case DeviceType.Ventilator:
      return '환풍기';
  }
};

const getControllerId = (data) => {
  return data._id ? data.controllerId : data.serial;
};

const onDetailClick = () => {
  console.log('DeviceItem.onDetailClick');
  // store.commit("home/setCurrentGroup",props.roomId )

  // router.push(`/rooms/${props.roomId}`);
};

const onDeleteClick = () => {
  console.log('DeviceItem.onDeleteClick =>', {
    name: props.data.name,
    deviceId: props.data._id,
  });
  emit('onDeleteClick', { name: props.data.name, deviceId: props.data._id });
};
</script>

<style scoped>
/* card-item 스타일은 전역 _helper.scss에서 정의됨 */
</style>
